import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { loadSelectedClinicId } from 'utils/storage';

interface IUseClinicInsuranceParams {
  shouldRun?: boolean;
  limit?: number | null;
  page?: number | null;
  sort?: string;
  sortBy?: string;
  axiosRequestConfig?: AxiosRequestConfig;
  clinicIds: string[];
  searchingValue: string;
}

const useClinicInsuranceCarrier = ({
  limit = 5,
  page = 1,
  sort = 'desc',
  sortBy = 'createdAt',
  shouldRun = true,
  axiosRequestConfig,
  clinicIds,
  ...rest
}: IUseClinicInsuranceParams) => {
  const params = {
    ...(limit !== null ? { limit: limit.toString() } : {}),
    ...(page !== null ? { page: page.toString() } : {}),
    sort: sortBy === 'isActive' ? `${sort},${sort}` : sort,
    sortBy: sortBy === 'isActive' ? `${sortBy},name` : sortBy,
    ...rest,
  };

  let query = new URLSearchParams(params);

  clinicIds.forEach((value) => {
    query.append('clinicIds[]', value);
  });

  const url = `/admin/insurances?${query.toString()}`;
  const clinicId = loadSelectedClinicId();

  const { data, error, mutate } = useSWR(
    shouldRun ? [url, clinicId, axiosRequestConfig?.headers] : false,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get(url, {
        ...axiosRequestConfig,
      });

      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useClinicInsuranceCarrier;
